<template>
    <div class="ticker-message">
		<div class="ticker-message--icon" :style="{backgroundColor: message.category?.color ?? $config.public.colors.light_gray}">
			<Icon :icon="icon" small :color="!message.category || message.category?.value === 'text' ? $config.public.colors.text : $config.public.colors.white"/>
		</div>
		<card class="ticker-message--content" outlined :loading="isDeleting">
            <card-image v-if="message.image" :src="message.image" :size="{width: 480, ratio: 3/2}"/>

            <card-title v-if="message.title">
				<div class="flex justify-between w-full">
                    <span>{{ message.title }}</span>

					<dropdown v-if="editable" left>
						<Icon :icon="icons.more" small color="gray-400" class="cursor-pointer hover:text-primary"/>
						<template #menu>
							<nav-list>
								<nav-list-item @click="$emit('edit')">{{ $t('action.edit') }}</nav-list-item>
								<form-nav-list-item :action="`/v1/events/${message.event_id}/ticker-messages/${message.id}`"
													method="DELETE"
													notification="destroyed"
													color="error"
													v-model:loading="isDeleting"
													@success="$emit('destroyed')"
													:confirm="{title: $t('confirm.ticker_messages.destroy.title'), message: $t('confirm.ticker_messages.destroy.message')}">
									{{ $t('action.destroy') }}
								</form-nav-list-item>
							</nav-list>
						</template>
					</dropdown>
				</div>

			</card-title>
			<card-text>
				<user-content :text="message.message"/>
			</card-text>
			<card-buttons v-if="message.created_at">
				<tooltip :text="$date(message.created_at).format('LLL')" with-touch top>
                    <time class="text-xs text-gray-450">{{ $date(message.created_at).calendar('LLL', 1, 'days') }}</time>
				</tooltip>
			</card-buttons>
		</card>
	</div>
</template>

<script>
import {EventTickerMessageCategory} from "@spoferan/spoferan-ts-core";
import {mdiAlert, mdiCheck, mdiExclamation, mdiMessageTextOutline} from "@mdi/js";
import {moreIcon} from "../../config";

export default {
    name: "TickerMessage",

	emits: ['edit', 'destroyed'],

    props: {
        message: {
            type: Object,
            required: true
        },

        editable: {
            type: Boolean,
            default: false
        }
    },

	data() {
		return {
			isDeleting: false,
			icons: {
				more: moreIcon
			}
		}
	},

	computed: {
        icon() {
			switch (this.message.category?.value) {
				case EventTickerMessageCategory.Success:
					return mdiCheck;
				case EventTickerMessageCategory.Warning:
					return mdiExclamation;
				case EventTickerMessageCategory.Danger:
					return mdiAlert;
			}
			return mdiMessageTextOutline;
		}
	}
}
</script>

<style>
/*********************
  Inputs
**********************/
.ticker-feed.ticker-feed--live .ticker-message:first-child .ticker-message--icon {
  box-shadow: 0 0 0 rgba(71, 164, 71, 0.4);
  animation: pulse 2s infinite;
}
.ticker-feed.ticker-feed--live .ticker-message:first-child .ticker-message--icon:hover {
  animation: none;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(71, 164, 71, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(71, 164, 71, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(71, 164, 71, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(71, 164, 71, 0.4);
    box-shadow: 0 0 0 0 rgba(71, 164, 71, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(71, 164, 71, 0);
    box-shadow: 0 0 0 10px rgba(71, 164, 71, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(71, 164, 71, 0);
    box-shadow: 0 0 0 0 rgba(71, 164, 71, 0);
  }
}

.ticker-message {
  display: flex;
  margin-bottom: 8px;
}
.ticker-message .ticker-message--content {
  max-width: 100%;
  width: 480px;
}
.ticker-message .ticker-message--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-left: -52px;
  margin-right: 16px;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: 0 0 0 6px #fff;
}
</style>